import Vue from "vue";
import VueCookie from 'vue-cookie'
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Admin from "./views/Admin.vue";
import Scrapbook from "./views/Scrapbook.vue";

Vue.use(Router);
Vue.use(VueCookie);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/scrapbook/:id",
      name: "scrapbook",
      component: Scrapbook
    }
  ]
});
